import { render } from "./PdfViewerModal.vue?vue&type=template&id=3146e64e&scoped=true"
import script from "./PdfViewerModal.vue?vue&type=script&lang=js"
export * from "./PdfViewerModal.vue?vue&type=script&lang=js"

import "./PdfViewerModal.vue?vue&type=style&index=0&id=3146e64e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3146e64e"]])

export default __exports__